import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText
} from '@mui/material'
import React from 'react'

import TrackedExternalLink from 'components/common/TrackedExternalLink'
import useAgent from 'hooks/use-agent'
import useAuth from 'hooks/use-auth'
import { useGremlinQuery } from 'hooks/use-gremlin-query'
import { PricingPlanTier } from 'types/api/companies/contracts'

const PrivateNetworkIntegrationCheckbox: React.FC<{
  isEnabled: boolean
  onChange: (e: any) => void
  name: string
}> = ({ isEnabled, onChange, name }) => {
  const { tier, currentTeamId, companyId } = useAuth()
  // TODO move this into useAuth
  const {
    data: [company]
  } = useAgent(`/companies/${companyId}`, [{ pricing_plan_name: null }], {
    shouldCache: true
  })

  const isEnterprise = !company?.pricing_plan_name
    ? tier === PricingPlanTier.Enterprise
    : company.pricing_plan_name === PricingPlanTier.Enterprise

  const { data: activeClients, isLoading: isLoadingClients } = useGremlinQuery(
    `/integration-clients/active?teamId=${currentTeamId}`,
    {},
    {
      enabled: isEnterprise,
      placeholderData: []
    }
  )

  const isIntegrationAgentAvailable = isLoadingClients
    ? null
    : Boolean(activeClients?.length)

  return (
    <FormControl component="fieldset" variant="standard">
      <FormControlLabel
        control={
          <Checkbox
            checked={isEnabled}
            color="primary"
            data-testid="team-integration-private-network-endpoint"
            disabled={!isEnterprise}
            name={name}
            onChange={onChange}
          />
        }
        label="Private Network Endpoint"
      />
      <FormHelperText>
        Check if your integration is not publicly accessible over the internet.
      </FormHelperText>
      {!isEnterprise && (
        <FormHelperText>
          <TrackedExternalLink
            href="https://www.gremlin.com/pricing/?ref=nav"
            target="_blank"
          >
            Upgrade
          </TrackedExternalLink>{' '}
          to use private network endpoints
        </FormHelperText>
      )}

      {isEnterprise && !isEnabled && isIntegrationAgentAvailable === false && (
        <FormHelperText data-testid="integration-agent-required">
          Requires{' '}
          <TrackedExternalLink
            href="https://www.gremlin.com/docs/integrations/installation/"
            target="_blank"
          >
            Integration Agent
          </TrackedExternalLink>
        </FormHelperText>
      )}

      {isEnabled && isIntegrationAgentAvailable === false && (
        <FormHelperText
          data-testid="integration-agent-no-agent-available"
          error={true}
        >
          No Integration Agent installed.{' '}
          <TrackedExternalLink href="https://www.gremlin.com/docs/">
            Install
          </TrackedExternalLink>
          {' to use private network endpoints.'}
        </FormHelperText>
      )}
    </FormControl>
  )
}

export default PrivateNetworkIntegrationCheckbox
